import { Group, Text } from "@mantine/core";
import clsx from "clsx";
import classes from "./Indicators.module.css";

export default function Indicators({
  attemptedTally,
  isReviewing,
  reviewCardsLength,
}: {
  attemptedTally: number;
  isReviewing: boolean;
  reviewCardsLength: number;
}) {
  return (
    <>
      <Group className={classes.group}>
        <Text
          className={clsx(classes.indicatorLabel, classes.alignCenter)}
        >{`${isReviewing ? "Reviewed" : "Attempted"}: ${attemptedTally}`}</Text>
        <Text className={clsx(classes.indicatorLabel, classes.alignRight)}>{`${
          isReviewing ? "In" : "To"
        } review: ${reviewCardsLength}`}</Text>
      </Group>
    </>
  );
}
